import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class BillingInvoiceStatus extends Enum {
  static PAID = {
    key: 'paid',
    get value() {
      return Lang.t('billing.paid');
    },
    get description() {
      return Lang.t('billing.indicates-paid-invoice');
    }
  };

  static POSTED = {
    key: 'posted',
    get value() {
      return Lang.t('billing.posted');
    },
    get description() {
      return Lang.t(
        'billing.indicates-be-date'
      );
    }
  };

  static PAYMENT_DUE = {
    key: 'payment_due',
    get value() {
      return Lang.t('billing.payment-due');
    },
    get description() {
      return Lang.t(
        'billing.indicates-is-being'
      );
    }
  };

  static NOT_PAID = {
    key: 'not_paid',
    get value() {
      return Lang.t('billing.not-paid');
    },
    get description() {
      return Lang.t('billing.indicates-is-failed');
    }
  };

  static VOIDED = {
    key: 'voided',
    get value() {
      return Lang.t('billing.voided');
    },
    get description() {
      return Lang.t('billing.indicates-voided-invoice');
    }
  };

  static PENDING = {
    key: 'pending',
    get value() {
      return Lang.t('asset.pending');
    },
    get description() {
      return Lang.t('billing.the-closed-for');
    }
  };
}
